import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Pencil } from 'react-bootstrap-icons';

export default function InventoryQuickField({ label, value, onSave, link = false, prefix = '', options, displayValue, disabled = false }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const save = async event => {
    event.preventDefault();
    if (saving) return;
    setSaving(true); setError('');
    try { await onSave(draft); setEditing(false); }
    catch (err) { setError(err.message || 'Unable to save. Please try again.'); }
    finally { setSaving(false); }
  };
  const shown = displayValue == null ? (value == null || value === '' ? '—' : value) : displayValue;
  if (!editing) return <span>{prefix}{shown}<Button variant="link" size="sm" className="p-1 d-print-none" disabled={disabled} aria-label={'Edit ' + label} onClick={() => { setDraft(value == null ? '' : String(value)); setError(''); setEditing(true); }}><Pencil size={12}/></Button></span>;
  return <><span className="d-none d-print-inline">{prefix}{shown}</span><Form onSubmit={save} style={{ minWidth: 180 }} className="d-print-none">
    {options ? <Form.Control as="select" size="sm" aria-label={label} value={draft} disabled={saving} onChange={event => setDraft(event.target.value)} autoFocus><option value="" disabled>Select home type</option>{options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}</Form.Control> : <Form.Control size="sm" aria-label={label} value={draft} disabled={saving} type={link ? 'text' : 'number'} min={link ? undefined : 0} step={link ? undefined : 'any'} onChange={event => setDraft(event.target.value)} autoFocus/>}
    {error && <div role="alert" className="text-danger small">{error}</div>}
    <Button size="sm" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save'}</Button>{' '}
    <Button size="sm" variant="outline-secondary" disabled={saving} onClick={() => setEditing(false)}>Cancel</Button>
  </Form></>;
}
